import jwtDefaultConfig from './jwtDefaultConfig'
import { LOGOUT } from '@/store/auth'
import store from '../../../store'

export default class JwtService {
  // Will be used by this service for making API calls
  axiosIns = null

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // For Refreshing Token
  subscribers = []

  constructor(axiosIns, jwtOverrideConfig) {
    // console.log('JwtService constructor')
    this.axiosIns = axiosIns
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      config => {
        // console.log('JwtService Interceptor request')
        // Get token from localStorage
        const accessToken = this.getToken()
        // console.log('JwtService Interceptor request')

        // If token is present add it to request's Authorization Header
        if (accessToken) {
          // eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
        }
        return config
      },
      error => Promise.reject(error),
    )

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(
      response =>
        // console.log('JwtService interceptors response ', response.data)
        response,
      error => {
        // console.log('JwtService interceptors response ')
        // const { config, response: { status } } = error
        const { config, response } = error
        const originalRequest = config

        // console.log('originalRequest', originalRequest)
        // console.log('JwtService interceptors response status :', response)

        // if (response === undefined) {
        //   alert(error)
        //   // console.log('status undefined')
        //   // store.dispatch('auth/logout')
        // }
        // if (response.status === 401) {
        //   // console.log('401 - LOGOUT')
        //   store.dispatch('auth/logout')
        // }
        // if (response.status === 403) {
        //   // console.log('403 - LOGOUT')
        //   store.dispatch('auth/logout')
        // }
        // if (status === 401) {
        // if (response && response.status === 401) {
        //   if (!this.isAlreadyFetchingAccessToken) {
        //     this.isAlreadyFetchingAccessToken = true
        //     this.refreshToken().then(r => {
        //       this.isAlreadyFetchingAccessToken = false
        //
        //       // Update accessToken in localStorage
        //       this.setToken(r.data.accessToken)
        //       this.setRefreshToken(r.data.refreshToken)
        //
        //       this.onAccessTokenFetched(r.data.accessToken)
        //     })
        //   }
        //   const retryOriginalRequest = new Promise(resolve => {
        //     this.addSubscriber(accessToken => {
        //       // Make sure to assign accessToken according to your response.
        //       // Check: https://pixinvent.ticksy.com/ticket/2413870
        //       // Change Authorization header
        //       originalRequest.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
        //       resolve(this.axiosIns(originalRequest))
        //     })
        //   })
        //   return retryOriginalRequest
        // }
        return Promise.reject(error)
      },
    )
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    // console.log('token fetch')
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName)
  }

  getAccountId() {
    // console.log('AccountId fetch')
    return localStorage.getItem(this.jwtConfig.accountId)
  }

  getCurrentAccountObj() {
    // console.log('accountObj fetch')
    return localStorage.getItem(this.jwtConfig.accountObj)
  }

  destroyToken() {
    // console.log('token destroyed')
    window.localStorage.removeItem(this.jwtConfig.storageTokenKeyName)
    window.localStorage.removeItem(this.jwtConfig.accountId)
    window.localStorage.removeItem(this.jwtConfig.accountObj)
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  setToken(value) {
    // console.log('token set')
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  setAccountId(value) {
    // console.log('AccountId set')
    localStorage.setItem(this.jwtConfig.accountId, value)
  }

  setCurrentAccountObj(value) {
    // console.log('setCurrentAccountObj set')
    localStorage.setItem(this.jwtConfig.accountObj, value)
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  login(...args) {
    return this.axiosIns.post(this.jwtConfig.loginEndpoint, ...args)
  }

  register(...args) {
    return this.axiosIns.post(this.jwtConfig.registerEndpoint, ...args)
  }

  refreshToken() {
    return this.axiosIns.post(this.jwtConfig.refreshEndpoint, {
      refreshToken: this.getRefreshToken(),
    })
  }
}
